import { createEntityAdapter } from '@reduxjs/toolkit'
import { Order } from './models/Order'

export const ordersAdapter = createEntityAdapter({
  selectId: (order: Order) => order.id,
})